import { Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-language-option',
  templateUrl: './language-option.component.html',
  styleUrl: './language-option.component.scss'
})
export class LanguageOptionComponent {
  input_option = input.required<String>();


}
